import type {VariableCatalogue} from "../model/types";

/**
 * One editor's catalogue. The node, the suggestion, the chips and the bubble menu all read this one
 * object, so a host that swaps the catalogue changes every one of them at once.
 */
export interface VariableCatalogueStore {
    get(): VariableCatalogue;
    set(next: VariableCatalogue): void;
    subscribe(listener: () => void): () => void;
}

/*
    Closures rather than a class: the chip hands `store.subscribe` and `store.get` to
    `useSyncExternalStore` unbound. `get` returns the very object last set, so React sees a change
    only when there is one.
 */
export function createVariableCatalogueStore(initial: VariableCatalogue): VariableCatalogueStore {
    let current = initial;
    const listeners = new Set<() => void>();

    return {
        get: () => current,

        set: next => {
            if (next === current) return;

            current = next;
            listeners.forEach(listener => listener());
        },

        subscribe: listener => {
            listeners.add(listener);

            return () => {
                listeners.delete(listener);
            };
        },
    };
}

export default createVariableCatalogueStore;
